// Copyright (c) 2022 by Move Closer

import { IToastOptions } from '../../../../backoffice/shared/services/toaster'

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export enum ToastType {
  Danger = 'danger',
  Info = 'info',
  Success = 'success',
  Warning = 'warning'
}

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export interface IToastsService<C extends string = string, O extends IToastOptions = IToastOptions> {
  getOptionsConfig (): IToastOptions
  show (content: C, type?: ToastType, title?: string, options?: O): void
}

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const ToastsServiceType = Symbol.for('IToastService')
